import { render, staticRenderFns } from "./SampleForm.vue?vue&type=template&id=3e24639c&"
import script from "./SampleForm.vue?vue&type=script&lang=js&"
export * from "./SampleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports